import { render, staticRenderFns } from "./CompraShow.vue?vue&type=template&id=574f282b"
import script from "./CompraShow.vue?vue&type=script&lang=js"
export * from "./CompraShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports